// File: utils/phone.js
//
// Helpers for handling US phone numbers in form inputs.
//
// Used by the Sign Up page and the Settings page so the phone field
// behaves the same way in both places. If you change anything here,
// both pages will get the new behavior.

// Strips out anything that isn't a digit. "(555) 123-4567" -> "5551234567".
export function digitsOnly(v = "") {
  return v.replace(/[^\d]/g, "");
}

// Same as digitsOnly but caps the result at 10 digits — US phone numbers
// are 10 digits, so this prevents users from typing extras.
export function cap10Digits(v = "") {
  return digitsOnly(v).slice(0, 10);
}

// Formats a digit string for display as the user types.
// "5551234567" -> "(555) 123-4567". Partial input is handled gracefully:
//   "555"       -> "555"
//   "5551234"   -> "(555) 123-4"
export function formatUSPhone(v = "") {
  const d = cap10Digits(v);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
